import React from 'react'
import ShareBtn from './module/shareIcon'
import Pagination from './pagination'
import { articleFooter } from '../styles/single.module.scss'
import { useLocation } from '@reach/router'

export default function ArticleFooter({ data, currPostId, filterArticle }) {
  let currPostNum
  for (let i = 0; i < filterArticle.length; i++) {
    if (filterArticle[i].node.id === currPostId) {
      currPostNum = i
      break
    }
  }

  const location = useLocation()
  const collection = location.pathname.replace(data.slug, '').replace(/\//g, '')

  return (
    <footer className={articleFooter}>
      <ShareBtn title={data.title} link={`${data.slug}`} />

      {filterArticle && <Pagination filterArticle={filterArticle} currPostNum={currPostNum} slug={collection} />}
    </footer>
  )
}
